<template>
  <div class="bg-white my-4 px-6 py-4">
    <div class="flex flex-col w-full">
      <h2 class="text-2xl font-bold mb-5">{{ organisation.name }}</h2>

      <div class="flex flex-wrap gap-4 justify-between">
        <div>
          <p v-if="organisation.address_line_1">
            {{ organisation.address_line_1 }},
          </p>
          <p v-if="organisation.address_line_2">
            {{ organisation.address_line_2 }},
          </p>
          <p v-if="organisation.city">{{ organisation.city }},</p>
          <p v-if="organisation.county">{{ organisation.county }},</p>
          <p v-if="organisation.eircode">
            {{ organisation.eircode }}
          </p>
        </div>

        <div>
          <div class="mb-3" v-if="organisation.email">
            <strong>Email: </strong> {{ organisation.email }}
          </div>
          <div v-if="organisation.telephone">
            <strong>Telephone:</strong> {{ organisation.telephone }}
          </div>
        </div>
      </div>

      <div class="flex flex-row mt-10 gap-10">
        <div>
          <h3 class="text-xs">Active</h3>
          <span class="text-lg font-bold">{{ organisation.enabled }}</span>
        </div>
        <div>
          <h3 class="text-xs">Vat No</h3>
          <span class="text-lg font-bold">{{ organisation.vat_no }}</span>
        </div>
      </div>

      <h3 class="text-xs mt-10 mb-1">Billing Options</h3>
      <div class="flex flex-row gap-10">
        <div>
          <h3 class="text-xs">Lab</h3>
          <span class="text-lg font-bold">{{
            organisation.billing_options?.lab
          }}</span>
        </div>
        <div>
          <h3 class="text-xs">Sample Collection</h3>
          <span class="text-lg font-bold">{{
            organisation.billing_options?.collection
          }}</span>
        </div>
        <div>
          <h3 class="text-xs">Timezone</h3>
          <span class="text-lg font-bold">{{ organisation.timezone }}</span>
        </div>
      </div>
    </div>

    <div class="flex justify-start mt-5">
      <inertia-link
        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :href="route('app.organisation.edit', organisation.id)"
      >
        Edit organisation
      </inertia-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    organisation: Object,
  },
};
</script>
